const ENV = process.env.REACT_APP_ENV;

export const RESERVE_BASE_URL =
    ENV === 'production'
        ? 'https://reserve.bookvara.com'
        : 'https://staging.reserve.bookvara.com';

export const APP_BASE_URL =
    ENV === 'production'
        ? 'https://app.bookvara.com'
        : 'https://staging.app.bookvara.com';
